module.exports = __webpack_public_path__ + "static/media/NellisAuction-black-trans.acc75bd2.png";